
import React from "react";

const viewDrawer = ({ cssDrawer, cssHandle }) => {
  return (
    <div className={cssDrawer}>
      <div className={cssHandle}></div>
    </div>
  );
};

export default viewDrawer;